<template>
  <div class="min-h-screen flex flex-col bg-gray-900 text-gray-200 font-sans">
    <header :class="{'sticky top-0 z-20': !isLandingPage, 'absolute top-0 w-full z-20': isLandingPage}"
            class="bg-gray-800 shadow-lg py-4 px-6 md:px-12 flex items-center justify-between transition-all duration-300">
      <div class="flex items-center space-x-8">
        <router-link to="/" class="text-3xl font-bold text-red-500">Rita<span class="text-white">Limão</span></router-link>
        <nav class="hidden md:flex space-x-6 text-gray-400">
          <router-link to="/makeup" class="hover:text-white transition-colors duration-200">Make up</router-link>
          <router-link to="/sfx" class="hover:text-white transition-colors duration-200">Prothetics & SFX</router-link>
          <router-link to="/hair" class="hover:text-white transition-colors duration-200">Hair & Wigs</router-link>
          <router-link to="/behind-scenes" class="hover:text-white transition-colors duration-200">Behind the Scenes</router-link>
          <router-link to="/movies" class="hover:text-white transition-colors duration-200">Credits</router-link>
          <router-link to="/cv" class="hover:text-white transition-colors duration-200">CV</router-link>
          <router-link to="/contact" class="hover:text-white transition-colors duration-200">Contact</router-link>
        </nav>
      </div>
      <div class="flex items-center space-x-4">
        <a href="https://www.instagram.com/rita_limao_films/" class="text-gray-400 hover:text-white transition-colors duration-200">
          <img src="@/components/icons/instagram.png" alt="Instagram logo" class="w-6 h-6">
        </a>
        <a href="https://www.linkedin.com/in/ritalimao/" class="text-gray-400 hover:text-white transition-colors duration-200">
          <img src="@/components/icons/linkedin.png" alt="Linkedin logo" class="w-6 h-6">
        </a>
        <button class="md:hidden text-gray-400 hover:text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>
      </div>
    </header>

    <div :class="{'flex-grow': !isLandingPage}">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLandingPage() {
      return this.$route.path === '/';
    }
  }
};
</script>

<style scoped>
.font-sans {
  font-family: 'Inter', sans-serif;
}
</style>